import { EVENT_INITIATORS } from '@zocdoc/frontend-metrics';

const validateSourceType = value => {
    if (value !== EVENT_INITIATORS.USER && value !== EVENT_INITIATORS.SYSTEM) {
        throw new Error('Source type of FLOW_SOURCE Class must be either user or system');
    }
};

const FLOW_SOURCE = class {
    constructor(sourceType, sourceValue) {
        validateSourceType(sourceType);

        this.sourceType = sourceType;
        this.sourceValue = sourceValue;
        Object.freeze(this);
    }
};

export const FLOW_SOURCE_ENUM = {
    Cookie: new FLOW_SOURCE(EVENT_INITIATORS.SYSTEM, 'Cookie'),
    Url: new FLOW_SOURCE(EVENT_INITIATORS.SYSTEM, 'Url'),
    StepByStep: new FLOW_SOURCE(EVENT_INITIATORS.USER, 'StepByStep'),
    Autocomplete: new FLOW_SOURCE(EVENT_INITIATORS.USER, 'Autocomplete'),
    CardExtraction: new FLOW_SOURCE(EVENT_INITIATORS.USER, 'CardExtraction'),
    SystemUnknown: new FLOW_SOURCE(EVENT_INITIATORS.SYSTEM, 'Unknown'),
};
